<a class="logo" routerLink="dashboard">
	<img alt="CareConnect into.care" src="./assets/images/logo_CC-intocare_HOR_white.png" />
</a>
@if (items()?.length) {
	<p-accordion
		collapseIcon="p-accordionheader-toggle-icon fa fa-angle-up"
		expandIcon="p-accordionheader-toggle-icon fa fa-angle-down"
		[value]="activeGroupIndex"
	>
		@for (menuItem of items(); track menuItem.label) {
			@if (menuItem.items) {
				<p-accordion-panel
					[attr.data-test]="'sidebar-group-' + menuItem.automationId"
					[ngClass]="menuItem.tabindex === activeGroupIndex ? 'router-link-active' : undefined"
					[value]="menuItem.tabindex!"
				>
					<p-accordion-header>
						<div class="p-accordion-header-link">
							@if (menuItem.icon) {
								<div class="relative">
									@if (menuItem.notificationCount?.()) {
										<div class="w-[9px] h-[9px] rounded-[50%] notification absolute top-[-2px] right-[5px]"></div>
									}
									<ic-fa-icon [icon]="menuItem.icon" />
								</div>
							} @else {
								@if (menuItem.notificationCount?.()) {
									<ic-fa-icon class="text-theme-secondary-500 notification text-xs mx-3" icon="fa fa-circle" />
								}
							}
							<span class="p-accordion-header-text" [attr.data-test]="menuItem.automationId">{{
								menuItem.label | translate
							}}</span>
						</div>
					</p-accordion-header>
					<p-accordion-content>
						<p-menu [model]="menuItem.items">
							<ng-template #item let-item>
								<a
									class="p-menu-item-link"
									pRipple
									routerLinkActive="p-menu-item-link-active"
									[attr.data-test]="item.automationId"
									[queryParamsHandling]="item.queryParamsHandling ?? ''"
									[routerLink]="item.routerLink"
									[routerLinkActiveOptions]="{ exact: !!item.routerLinkActiveOptions?.exact }"
									(isActiveChange)="onMenuItemActiveChange($event, menuItem.tabindex!)"
								>
									<span class="p-menu-item-text">{{ item.label | translate }}</span>
									@if (item.notificationCount?.(); as count) {
										<span class="text-theme-secondary-500 font-bold ml-auto" data-test="notification-count">{{
											count > 99 ? "99+" : count
										}}</span>
									}
									@if (item.isNewFunctionality) {
										<icds-new-functionality-tag class="ml-auto" />
									}
								</a>
							</ng-template>
						</p-menu>
					</p-accordion-content>
				</p-accordion-panel>
			} @else {
				<p-accordion-panel
					class="p-accordionpanel no-content"
					routerLinkActive="router-link-active"
					[routerLinkActiveOptions]="{ exact: !!menuItem.routerLinkActiveOptions?.exact }"
					(isActiveChange)="onMenuItemActiveChange($event, '-1')"
				>
					<p-accordion-header>
						<a
							class="p-accordion-header-link"
							pRipple
							role="menuitem"
							tabindex="0"
							[attr.data-test]="menuItem.automationId"
							[queryParamsHandling]="menuItem.queryParamsHandling ?? ''"
							[routerLink]="menuItem.routerLink"
						>
							@if (menuItem.icon) {
								<ic-fa-icon [icon]="menuItem.icon" />
							}
							<span class="p-accordion-header-text">{{ menuItem.label | translate }}</span>
						</a>
						<ng-template #toggleicon />
					</p-accordion-header>
				</p-accordion-panel>
			}
		}
	</p-accordion>
}

<ic-account-menu [userDisplayName]="(user$ | async) || ''" [userMainFunction]="userMainFunctionLabel()" />
